import { render, staticRenderFns } from "./poi-filter.vue?vue&type=template&id=5351671c&"
import script from "./poi-filter.vue?vue&type=script&lang=ts&"
export * from "./poi-filter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports